import React, { useEffect, useState } from "react";
import "./Hero.css";

function Hero() {
  const [currentWord, setCurrentWord] = useState(0);
  const words = ["Innovation", "Intelligence", "Excellence", "Solutions"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title animate-fadeInUp">
            Pioneering{" "}
            <span className="dynamic-word">{words[currentWord]}</span>
            <br />
            in Technology & Consulting
          </h1>
          <p className="hero-description animate-fadeInUp">
            SPA Holdings delivers cutting-edge AI, cloud solutions, and
            strategic consulting services that transform businesses across South
            Africa and beyond.
          </p>
          <div className="hero-buttons animate-fadeInUp">
            <a href="#services" className="btn btn-primary">
              Explore Our Services
            </a>
            <a href="#contact" className="btn btn-secondary">
              Get in Touch
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="floating-card card-1">
            <div className="card-icon">AI</div>
            <h4>Artificial Intelligence</h4>
          </div>
          <div className="floating-card card-2">
            <div className="card-icon">☁️</div>
            <h4>Cloud Services</h4>
          </div>
          <div className="floating-card card-3">
            <div className="card-icon">📊</div>
            <h4>Data Analytics</h4>
          </div>
          <div className="floating-card card-4">
            <div className="card-icon">🚚</div>
            <h4>Logistics</h4>
          </div>
        </div>
      </div>

      <div className="hero-wave">
        <svg viewBox="0 0 1440 320">
          <path
            fill="#ffffff"
            fillOpacity="1"
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
    </section>
  );
}

export default Hero;
